// extracted by mini-css-extract-plugin
export default {"PageLogo":"Login_PageLogo__-S5B6"};